module.exports = __webpack_public_path__ + "media/images/map/minus-icon-a475f37c6e04ea662531cf776bc6bd4b.svg";